import { render, staticRenderFns } from "./AdminCard.vue?vue&type=template&id=0cd459fe&scoped=true&"
import script from "./AdminCard.vue?vue&type=script&lang=js&"
export * from "./AdminCard.vue?vue&type=script&lang=js&"
import style0 from "./AdminCard.vue?vue&type=style&index=0&id=0cd459fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd459fe",
  null
  
)

export default component.exports